// Project Imports
import ProductConstants from 'constants/ProductConstants';
import Product from 'constants/ProductConstants';

const fetchLifeCoverBenefit = (solutionData) => {
    let lifeCoverList = []
    const productWithNoLifeCover = []

    const listOfProductWithNoLifeCover = [Product.FOREVER_PENSION_IMMEDIATE_ANNUITY,Product.FOREVER_PENSION_DEFERRED_ANNUITY,Product.GUARANTEED_SAVINGS_STAR_LUMPSUM,Product.ACTIVE_PENSION_PLUS]

    solutionData.coverage.forEach((coverage) => {
        coverage.life_assured_list.forEach(lifeAssured => {
            lifeAssured.product_details.forEach(obj => {
                let productName = obj.product_name

                if(listOfProductWithNoLifeCover.includes(productName)){
                    productWithNoLifeCover.push(productName)
                }

                let isLifeCoverApplicable = productName !== Product.CRITICARE_PLUS &&
                    productName !== Product.EASY_PENSION &&
                    productName !== Product.SARAL_PENSION &&
                    productName !== Product.FOREVER_PENSION_DEFERRED_ANNUITY &&
                    productName !== Product.POS_FOREVER_PENSION &&
                    productName !== Product.BHARAT_SAVINGS_STAR_INCOME &&
                    productName !== Product.BHARAT_SAVINGS_STAR_LUMPSUM &&
                    productName !== Product.POS_BHARAT_SAVINGS_STAR_INCOME &&
                    productName !== Product.POS_BHARAT_SAVINGS_STAR_LUMPSUM &&
                    productName !== Product.ACTIVE_PENSION_PLUS



                if (isLifeCoverApplicable) {
                    let policyTerm = obj.data.InputString.find((item) => item.Key == "@PR_PT")?.Value
                    lifeCoverList.push({ policyTerm: Number(policyTerm), memberType:lifeAssured.la_family_member_type,laName: lifeAssured.la_name, productName: productName })
                }
            })
        })
    })

    let lifeCoverMsg = ""

    const ptList = lifeCoverList.map(object => { return object.policyTerm; });
    const maxPt = Math.max(...ptList);

    let maxPtList = []
    lifeCoverList.map((lifeCover) => {
        if (lifeCover.policyTerm === maxPt) {
            maxPtList.push(lifeCover)
        }
    })

    // let maxData = maxPtList[maxPtList.length - 1]

    // console.log('maxData.laName',maxData.laName,maxPtList,lifeCoverList);



    // if (maxData) {
    //     if (maxData.productName === ProductConstants.CASH_FLOW_PROTECTION_PLUS) {
    //         lifeCoverMsg = "Life Cover till age 99"
    //     } else if(!productWithNoLifeCover.includes(Product.GUARANTEED_SAVINGS_STAR_LUMPSUM) && !productWithNoLifeCover.includes(Product.FOREVER_PENSION_IMMEDIATE_ANNUITY) && !productWithNoLifeCover.includes(Product.FOREVER_PENSION_DEFERRED_ANNUITY)){
    //         lifeCoverMsg = `Life Cover for ${maxData.policyTerm} years for ${maxData.laName || maxData.memberType}`
    //     }
    // }

    // return lifeCoverMsg



    if(lifeCoverList.length > 1){

        const memberList = [...new Set(lifeCoverList.map(el => el.memberType))]
        
        const arrayOfMembers = memberList.map(item =>  lifeCoverList.filter(obj => obj.memberType === item))

         lifeCoverList = arrayOfMembers.map(arryList => {

            const memberObj = {}
            const ptList = []
            const productList = []
            arryList.forEach(obj =>{
                ptList.push(obj.policyTerm)
                productList.push(obj.productName)
                memberObj['laName'] = obj.laName
                memberObj['memberType'] = obj.memberType
                memberObj['productName'] = obj.productName
            })

            const maxPt = Math.max(...ptList)
            memberObj.policyTerm = maxPt
            memberObj.productList = productList

            return memberObj

        })
    }else{
        if(lifeCoverList.length != 0 ) {
        const productList = []
        productList.push(lifeCoverList[0].productName)
        lifeCoverList = [{...lifeCoverList[0],productList}]
        }
    }

    const lifeCoverArray = []

    // lifeCoverList.forEach((item) => {
    //             if (item.productName === ProductConstants.CASH_FLOW_PROTECTION_PLUS) {
    //         lifeCoverMsg = "Life Cover till age 99"
    //     } else if(!productWithNoLifeCover.includes(Product.GUARANTEED_SAVINGS_STAR_LUMPSUM) && !productWithNoLifeCover.includes(Product.FOREVER_PENSION_IMMEDIATE_ANNUITY) && !productWithNoLifeCover.includes(Product.FOREVER_PENSION_DEFERRED_ANNUITY)){
    //         lifeCoverMsg = `Life Cover for ${item.policyTerm} years for ${item.laName || item.memberType}`
    //         lifeCoverArray.push(lifeCoverMsg)
    //     }
    // })

    lifeCoverList.forEach((item) => {
        if (item.productList.includes(ProductConstants.CASH_FLOW_PROTECTION_PLUS)) {
    lifeCoverMsg = "Life Cover till age 99"
    lifeCoverArray.push(lifeCoverMsg)
} else if(!item.productList.includes(Product.GUARANTEED_SAVINGS_STAR_LUMPSUM) && !item.productList.includes(Product.FOREVER_PENSION_IMMEDIATE_ANNUITY) && !item.productList.includes(Product.FOREVER_PENSION_DEFERRED_ANNUITY) && !item.productList.includes(Product.ACTIVE_PENSION_PLUS)){
    lifeCoverMsg = `Life Cover for ${item.policyTerm} years for ${item.laName || item.memberType}`
    lifeCoverArray.push(lifeCoverMsg)
}
})
    

    return lifeCoverArray

}

export default fetchLifeCoverBenefit